import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { ContentBox, ContentBoxIcon, ViewButton } from "../../components";
import * as commonStyles from "../../components/commonStyles/commonStyles.module.css";
import { PitchConceptIdSearchParam } from "../../helpers/dataFetchingHelpers";
import { useStrings } from "../../localization/localizationHelpers";
import { PitchConceptData } from "../../models/forms";
import { Forms, FormsConfiguration } from "../../models/programsConfig";
import { RouteNames } from "../../partnerConfig/routeNames";
import { OnboardingUrls } from "../../partnerConfig/routes";
import { OnboardingRootState } from "../../redux/reducers/rootReducer";
import { getCurrentPitchConcept, getFormData } from "../../redux/selectors";
import { OnboardingPageAction } from "../../telemetry/models";
import { logPageAction } from "../../telemetry/pageAction";

export const PitchInformationReadOnly = () => {
  const [pitchInformationReadOnlyTitle, complete] = useStrings(
    "pitchInformationReadOnlyTitle",
    "complete"
  );
  const history = useHistory();
  const currentPitchConcept = useSelector(getCurrentPitchConcept);

  const formConfiguration = FormsConfiguration[Forms.PitchInformation];
  const pitchInformationData = useSelector((state: OnboardingRootState) =>
    getFormData(state, formConfiguration.formId)
  );
  const currentPitchInformationApplication =
    (pitchInformationData?.subForms as PitchConceptData) ?? null;

  if (!currentPitchInformationApplication) {
    return null;
  }

  return (
    <ContentBox
      titleConfiguration={{
        title: currentPitchInformationApplication.aboutYourGame.gameTitle,
        icon: ContentBoxIcon.CheckMark,
        rightSideText: complete,
      }}
    >
      <div className={commonStyles.rowContainer}>
        <div className={commonStyles.titleStatusContainer}>
          <div className={commonStyles.gameTitle}>{pitchInformationReadOnlyTitle}</div>
        </div>
        <ViewButton
          onClick={() => {
            logPageAction(OnboardingPageAction.ViewGameConceptLink);
            return history.push({
              pathname: OnboardingUrls[RouteNames.PitchFormPreview],
              search: `?${PitchConceptIdSearchParam}=${currentPitchConcept?.id}`,
            });
          }}
        />
      </div>
    </ContentBox>
  );
};
